import {QualificationsList} from "./QualificationsList";
import {QualificationsEdit} from "./QualificationsEdit";
import {QualificationsCreate} from "./QualificationsCreate";

export default {
    list: QualificationsList,
    create: QualificationsCreate,
    edit: QualificationsEdit
};
